import { Folder, Document } from '@/gql/graphql';
import { FolderTreeItem } from '@/types/file';

export const createFolderTree = (folder: FolderTreeItem): Folder => {
  // Remove the "text" property from every document
  const cleanDocuments = folder.documents?.map((doc) => {
    // Using _text to indicate we intentionally ignore this variable
    const { text: _text, ...rest } = doc;
    return rest as Omit<Document, 'text'>;
  });

  // Recursively map subfolders if they exist
  const cleanSubFolders = folder.subFolders?.map((subFolder) => createFolderTree(subFolder));

  // Return a new object conforming to the Folder structure
  const result: Folder = {
    ...folder,
    documents: cleanDocuments || [],
    subFolders: cleanSubFolders || []
  };

  return result;
};
